module.exports = __webpack_public_path__ + "img/icon_t20.6dd3cd8b.png";